<template>
	<div class="content py-0">
		<div class="" itemscope itemtype="http://schema.org/Recipe">
			<div class="row">
				<div class="col-md-8 col-xs-12 my-0">
					<div class="recipe-image" itemtype="http://schema.org/ImageObject">
						<div class="image-container">
							<img :src="recipe.images.big" itemprop="image" class="img" :alt="recipe.name">
						</div>
					</div>

					<div class="right info-small recipe-block">* immagine a puro scopo illustrativo</div>
					
					<div class="recipe-extra-description" v-if="isElectrolux">
						<h2>Vuoi saperne di più sui forni a vapore?</h2>
						<div>
							Scopri le differenze rispetto ad un forno tradizionale e in più altre idee e ricette pensate per il forno a vapore. <router-link :to="{ name: 'electrolux' }" class="link-detail">Scopri di più</router-link>
						</div>
					</div>
				</div>

				<div class="col-md-4 col-xs-12">
					
					<tags-line-orange
						:items="filterMarketingTags"
					/>

					<tag-price
						v-if="orderStore.order && orderStore.order.plan"
						:item="recipe"
						:people="orderStore.order.plan.people"
					/>

					<h1 class='recipe-title' itemprop='name' >{{ recipe.name }}</h1>
					<span style='display:none' itemprop='keywords'>{{ recipe.name }}</span>
					<span style='display:none' itemprop='author'>Quomi</span>
					<div class="recipe-block-nutrition-tags">
						<span v-for="(tag, index) in recipe.tags" v-if="tagIsNutrition(tag)" :key="index">{{ tag.name }}</span>

						<span v-if="isElectrolux">
							| Creata per <img class="logo" :src="require('../assets/img/campaigns/electrolux/electrolux_logo_blue.jpg')">
						</span>
					</div>



					<div
						class="flex flex-vcenter"
					>
						<span>Condividi con:&nbsp;</span>

						<social-share
							@shared="shared"
							:facebook="`${link}`"
							:whatsapp="`Cosa ne pensi di questa ricetta? ${link}`"
							:mail="{ subject: 'Cosa ne pensi di questa ricetta?', body: `Io credo sia imperdibile! ${link}` }"
							:copyString="link"
							:size="`small`"
						/>
					</div>

					<template v-if="!isMixedBox">
						<template v-if="recipe.nutrition && recipe.nutrition.calories">
							<div class="recipe-block-usp">
								<div class="usp-inner-text">
									<div><i class="far fa-clock"></i></div>
									<div>
										<time :datetime="recipe.preparation_time_m" itemprop="totalTime">
											{{ $t("components.recipe.time") }} <br>{{ recipe.preparation_time }} {{ $t("general.minutes") }}
										</time>
									</div>
								</div>

								<div class="usp-inner-text">
									<div>
										<i class="fas fa-fire" />
									</div>
									<div>Per porzione<br>{{ recipe.nutrition.calories }} Kcal</div>
									<div hidden><span itemprop="calories">{{ recipe.nutrition.calories * 1000 }}</span> Cal</div>
								</div>

							</div>
						</template>

						<template v-else>
							<div class="recipe-block-usp">
								<div>
									<i class="far fa-clock" />
									<time :datetime="recipe.preparation_time_m" itemprop="totalTime">
										{{ $t("components.recipe.time") }} {{ recipe.preparation_time }} {{ $t("general.minutes") }}
									</time>
								</div>
							</div>
						</template>
					</template>

					<div
						class="recipe-block-description"
						itemprop="description"
						v-html="recipe.description"
					/>
					<div v-if="typeCTA === 'modal'" class="recipe-action">
						<!--<CTA
							v-if="isRecipeAvailable"
							:content="isRecipeInBox ? 'Nel box' : 'Aggiungi'"
							:class="{ 'in-box': isRecipeInBox, 'not-in-box': !isRecipeInBox, 'disabled': isMaxRecipesReached && !isRecipeInBox }"
							@click="$emit('recipeAction', recipe)"
							:disabled="updating"
						/>-->
					</div>
					<div v-else>
						<router-link :to="{ name: 'flow-subscribed', query: {recipe_id: recipe.id} }">
							<CTA
								:content="`${ $root.user && $root.user.isSubscribed() ? 'Scopri il menù di oggi' : 'Fai la tua spesa' }`"
								isArrow
							/>
						</router-link>
					</div>
				</div>
			</div>

			<hr>

			<div class="row">
				<div class="col-md-8 col-sm-12 mb-0">

					<div class='recipe-block-ingredient'>
						<h2>{{ isMixedBox ? `Cosa ci sarà nella cassetta` : $t("components.recipe.what_we_send") }}</h2>
						<p>{{ $t("components.recipe.what_we_send_sub") }}</p>
						<div class="recipe-ingredient-list">

							<div class="badge-ingredient" v-for="(ingredient, index) in recipe.ingredients" :key="index">

								<template v-if="ingredient.isSpecial">
									<router-link :to="{ name: ingredient.link }" target="_blank">
										<p class="label-special-ingredient">Scopri</p>
										<img class="img-rounded" :src="ingredient.images.small" :alt="ingredient.name" loading="lazy">
									</router-link>
								</template>

								<template v-else>
									<img class="img-rounded" :src="ingredient.images.small" :alt="ingredient.name" loading="lazy">
								</template>

								<div class='badge-ingredient-name' itemprop='recipeIngredient'>
									{{ ingredient.name }}<!--<span v-if="showWeight(ingredient)"> &bull; <nobr>{{ ingredient.weight }} g</nobr>--></span>
								</div>
							</div>
						</div>
					</div>

					<div class='recipe-ingredient' v-if="recipe.products_at_home && !isMixedBox">
						<h2>{{ $t("components.recipe.what_you_should_have") }}</h2>
						<div class="recipe-home-list" v-html="recipe.products_at_home"></div>
					</div>
				</div>

				<div class="col-md-4 col-sm-12">
					<template v-if="showNutritions">
						<div class='recipe-block recipe-nutration' itemprop="nutrition" itemscope itemtype="http://schema.org/NutritionInformation">
							<h2>Dichiarazione nutrizionale*</h2>
							<div class="info-small-normal">Per singola porzione</div>

							<div class="nutrition">
								<div class="flex">
									<div>Energia</div>
									<div class='flex-right'>{{ recipeNutrition('calories') }} Kcal/{{ recipeNutrition('joules') }} kJ</div>
								</div>

								<div>
									<div class="flex">
										<div>Grassi</div>
										<div class='flex-right' itemprop="fatContent">{{ recipeNutrition('fat') }} g</div>
									</div>

									<div class="flex">
										<div>di cui acidi grassi saturi</div>
										<div class='flex-right' itemprop="saturatedFatContent">{{ recipeNutrition('saturates') }} g</div>
									</div>
								</div>

								<div>
									<div class="flex">
										<div>Carboidrati</div>
										<div class='flex-right' itemprop="carbohydrateContent">{{ recipeNutrition('carbohydrate') }} g</div>
									</div>
									<div class="flex">
										<div>di cui zuccheri</div>
										<div class='flex-right'  itemprop="sugarContent">{{ recipeNutrition('sugars') }} g</div>
									</div>
								</div>

								<div class="flex">
									<div>Fibre</div>
									<div class='flex-right' itemprop="fiberContent">{{ recipeNutrition('fibre') }} g</div>
								</div>

								<div class="flex">
									<div>Proteine</div>
									<div class='flex-right' itemprop="proteinContent">{{ recipeNutrition('protein') }} g</div>
								</div>

								<div class="flex">
									<div>Sale</div>
									<div class='flex-right'>{{ recipeNutrition('salt') }} g</div>
								</div>
							</div>
						</div>

					</template>

					<template v-else>
						<div class="recipe-block recipe-section">
							<h2>{{ isMixedBox ? `Dettagli Cassetta` : $t("components.recipe.preparation") }}</h2>
							<div class="recipe-preparation" v-html='format(recipe.preparation)' itemprop="recipeInstructions"></div>
						</div>
					</template>

					<div class="recipe-block" v-if="recipe.allergens.length > 0">
						<h2>Allergeni</h2>

						<div v-for="allergen in recipe.allergens" :key="allergen.id">
							<span v-text="allergenName(allergen)"></span>
						</div>
					</div>

				</div>
			</div>

			<hr>

			<template v-if="showNutritions">
				<div class="col-xs-12">
					<div class="recipe-section">
						<h2>{{ $t("components.recipe.preparation") }}</h2>
						<div class="recipe-preparation" v-html='format(recipe.preparation)' itemprop="recipeInstructions"></div>
					</div>
				</div>

				<hr>
			</template>

			<div class="info-small mb-5">*Le informazioni nutrizionali di Quomi si applicano solo agli ingredienti forniti da Quomi. Il processo di preparazione e gli ingredienti aggiunti a casa (elencati sotto "Cosa avere in dispensa") influiranno sui valori totali. </div>

			<div class="info-small">Origini, categorie, marchi di identificazione sanitari, modalità di confezionamento, lotti e scadenze: riportati su ciascun prodotto all’interno del box Quomi.</div>

			<div class="info-small-normal">
				<p><br>
				Imballato per Quomi Srl<br>
				via A. Sangiorgio 12 - 20145 Milano<br>
				nello stabilimento di:<br>
				Via Privata Oglio 18/20, 20098 San Giuliano Milanese (MI)
				</p>
				<p><b>Conservare a temperatura max +4°C</b></p>
			</div>
		</div>
	</div>
</template>

<script>

import TagsLineOrange from './Parts/TagsLineOrange'
import TagPrice from './Parts/TagPrice'
import CTA from './Elements/CTA'
import ShareIcon from './SocialShare/ShareIcon'
import SocialShare from './SocialShare/SocialShare'

import { orderStore } from '../store/orderStore'

import { dataLayer } from '../mixins/gtc'

export default {
	props: {
		typeCTA: {
			type: String,
			default: null
		},

		recipe: {
			type: Object,
			default () {
				return null
			}
		}
	},

	mixins: [
		dataLayer
	],

	components: {
		TagsLineOrange,
		TagPrice,
		CTA,
		ShareIcon,
		SocialShare
	},

	data () {
		return {
			link: process.env.VUE_APP_BASE_URL + '/ricetta/' + this.recipe.url,
			orderStore: orderStore.state,
		}
	},

	computed: {
		updating () {
			return this.$attrs.updating
		},

		isMaxRecipesReached () {
			return this.$attrs.isMaxRecipesReached
		},

		recipes () {
			return this.$attrs.recipes
		},

		style () {
			return {
				backgroundImage: 'url("' + this.recipe.images.big + '")'
			}
		},

		showNutritions () {
			return this.recipe.isNutritioinCompleted()
		},

		filterMarketingTags () {
			if (!this.recipe) return
			return this.recipe.tags.filter(tag => tag.type === 'marketing')
		},

		isRecipeInBox () {
			if (!this.$root.$data.user) return false
			return !!this.recipes.find(r => this.recipe.id === r)
		},

		isRecipeAvailable () {
			return this.recipe.available || this.isRecipeInBox
		},

		isElectrolux () {
			return this.recipe.tags.find(r => r.name.toLowerCase().includes('electrolux'))
		},

		isMixedBox () {
			return this.recipe.tags.find(tag => tag.name.toLowerCase() === 'box-mixed')
		}
	},

	methods: {
		recipeAction ($event) {
			this.$emit('recipeAction', $event)
		},

		tagIsNutrition (tag) {
			return tag.type === 'nutrition'
		},

		recipeNutrition (nutrition) {
			if (!nutrition || !this.recipe) return
			return +this.recipe.nutrition[nutrition].toFixed(1)
		},

		allergenName (allergen) {
			return this.$t('components.recipe.allergens.' + allergen.name.toLowerCase().replace(/\s+/g, '_'))
		},

		showWeight (ingredient) {
			return ingredient.weight > 0
		},

		format (text) {
			function insertBeforeAndAfterFirstOccurrence (strToSearch, strToFind, strToInsertBefore, strToInsertAfter) {
				var n = strToSearch.indexOf(strToFind)
				if (n < 0) { return strToSearch }
				return strToSearch.substring(0, n) + strToInsertBefore + strToSearch.substring(n, n + strToFind.length).slice(0, -1) + strToInsertAfter + strToSearch.substring(n + strToFind.length)
			}

			var result = text

			if (!result) return

			var array = []

			for (let i = 0; i < 99; i++) {
				let s = i + '.'
				array.push(s)
			}

			var before = '<div class="prep-step"><span>'
			var after = '</span></div>'

			array.forEach(item => {
				result = insertBeforeAndAfterFirstOccurrence(result, item, before, after)
			})

			return result
		},

		shared (params) {
			this.$_dataLayer_dataLayerRecipeShare({
				recipeId: this.recipe.id,
				recipeName: this.recipe.name,
				social: params.social
			})
		}
	},

	mounted () {

	}
}

</script>

<style>
.prep-step {
	color: white;
	font-weight: bold;
	background: var(--quomi-primary);
	border-radius: 50%;
	display: inline-block;
	width: 28px;
	height: 28px;
	margin: 5px 5px 5px 0;

}

.prep-step > span {
	display: flex;
	justify-content: center;
	align-items: center;
	line-height: 1.9;
	transform: translateY(-1px);
}

</style>

<style scoped>

.logo {
		height: 20px;
	}

[class*="recipe-block"] {
	margin-bottom: 30px;
}

[class*="recipe-"] h2 {
	font-weight: bold;
	font-size: 25px;
	margin-top: 0;
	text-align: left;
}

[class*="recipe-title"] {
	font-size: 30px;
	font-weight: bold;
	margin-top: 0;
	text-align: left;
}

hr {
	margin-bottom: 30px;
}

.row {
	display: flex;
	flex-wrap: wrap;
}

.row + .row {
	padding-top: 30px;
}

.row > div {
	margin-bottom: 30px;
}

.recipe-image {
	position: relative;
	min-height: 530px;
	overflow: hidden;
}

.share-icon {
	position: absolute;
	right: 10px;
	top: 10px;
	z-index: 1;
}

.icons-panel {
	justify-content: flex-start;
}

.img {
	width: 100%;
	max-width: inherit;
	position: absolute;
	transform: translate(-50%, -50%);
	top: 50%;
	left: 50%;
}

.image-container {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
}

.btn {
	width: 100%;
}

.disabled.btn {
	opacity: 0.5;
}

.recipe-action .btn {
	border: 1.5px solid var(--quomi-primary);
	background: var(--quomi-primary);
	color: white;
	padding: 10px;
	width: 100%;
	margin-bottom: 0;
}

.recipe-action .btn::before {
	content: '\002713 \000020';
}

.recipe-action .btn.not-in-box {
	background: white;
	color: var(--quomi-primary);
}

.recipe-action .btn.not-in-box::before {
	content: '+ \000020';
}


.recipe-title {
	padding-left: 0;
}

.recipe-block-nutrition-tags span {
	display: inline-block;
	color: #575A5C;
	text-transform: lowercase;
	padding-right: 5px;
}

.recipe-block-nutrition-tags span:not(:last-of-type)::after {
	content: ', ';
}

.recipe-block-usp {
	margin-top: 23px;
	border-top: 1px solid #ededed;
	border-bottom: 1px solid #ededed;
	display: flex;
	justify-content: space-between;
}

.recipe-block-usp > div  {
	flex-basis: 48%;
	padding: 15px 0;
	position: relative;
}

.recipe-block-usp > .usp-inner-text {
	text-align: center;
}

.recipe-home-list,
.recipe-preparation,
.recipe-block-description  {
	line-height: 2;
	white-space: pre-line;       /* css-3 */
	white-space: -moz-pre-line;  /* Mozilla, since 1999 */
	white-space: -pre-line;      /* Opera 4-6 */
	white-space: -o-pre-line;    /* Opera 7 */
	word-wrap: break-word;       /* Internet Explorer 5.5+ */
}

.preparation-step {
	color: white;
	display: inline-block;
	background: blue;
	border-radius: 50%;
}

.recipe-ingredient-list {
	display: flex;
	flex-wrap: wrap;
	margin: 0 -10px;
}

.badge-ingredient {
	margin: 10px;
	position: relative;
	max-width: 180px;
	width: calc(100% / 2 - 20px);
}

.badge-ingredient-name {
	white-space: normal;
	word-break: break-word;
	display: block;
	margin-top: 5px;
	font-size: 15px;
}

.label-special-ingredient {
	font-weight: bold;
	color: white;
	position: absolute;
	background-color: orange;
	top: 0;
	width: 100%;
	text-align: center;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
}

.label-special-ingredient a {
	color: white;
}

.nutrition {
	margin-top: 20px;
	max-width: 300px;
}

.nutrition > div {
	padding: 2px 5px;
}

.nutrition > div:nth-child(2n-1) {
	background-color: var(--quomi-primary)2e;
}

.nutrition > div > div:nth-child(2) {
	padding-left: 17px;
}

@media (max-width: 1024px) {
	[class*="recipe-title"],
	[class*="recipe-"] h2 {
		font-size: 20px;
	}
}

 @media only screen and (max-width: 992px) {
	.recipe-image {
		padding-bottom: 63%;
		height: 0;
		min-height: 0;
	}
}
</style>
